var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-wrapper"},[_c('div',{staticClass:"calculator"},[_c('CalculatorHeading',{attrs:{"step":_vm.step}}),_c('SelectInput',{attrs:{"question":_vm.$t('project.question'),"selections":[
        {
          image: require('@/assets/construct.svg'),
          name: _vm.$t('project.new'),
          value: 'new'
        },
        {
          image: require('@/assets/renovation.svg'),
          name: _vm.$t('project.renovation'),
          value: 'renovation'
        }
      ],"selected-value":_vm.projectType,"clicked-callback":_vm.onSelect}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }